<template>
  <div>
    <table class="table table-hover miSeleccion totales"> 
      <thead> 
        <tr>
          <th width=" 9%" colspan="2"></th>
          <th width=" 4%" class="center"></th> 
          <th width="30%"></th> 
          <th width="20%"></th> 
          <th width="10%"></th> 
          <th width=" 6%"></th> 
          <th width=" 9%"></th> 
          <th width=" 8%"></th> 
          <th width=" 4%"></th>
        </tr> 
      </thead> 
      <tfoot>
        <tr class="selected-data">
          <td class="center">{{ $t('TOTALES') }}</td>
          <td></td>
          <td class="center">{{ ArticulosMarcados }}</td>
          <td colspan="4">{{ $t('Artículos marcados') }}</td>
          <td class="align-right">{{ CantidadArticulosMarcados }}</td>
          <td class="align-right">{{ toCurrency(ImporteTotalMarcados) }}</td>
          <td></td>
        </tr>
        <tr class="unselected-data">
          <td></td>
          <td></td>
          <td class="center">{{ AllArticulos - ArticulosMarcados }} </td>
          <td colspan="4">{{ $t('Artículos no marcados') }}</td>
          <td class="align-right">{{ CantidadArticulosNoMarcados }}</td>
          <td class="align-right">{{ toCurrency(ImporteTotalNoMarcados) }}</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td colspan="4">
            <a href="#" :class="'buy-link '+ tipo" @click.prevent="checkAll()">{{ $t('Marcar todos') }}</a>
            <a href="#" :class="'buy-link '+ tipo" @click.prevent="uncheckAll()">{{ $t('Desmarcar todos') }}</a>
            <a href="#" :class="'buy-link '+ tipo" @click.prevent="deleteAll()">{{ $t('Vaciar todas las listas') }}</a>
            <!-- <a :href=" getApiUrl + '/es/mipresupuesto'" :class="'buy-link float-right '+ tipo + ( CantidadArticulosMarcados ? '' : ' buy-type-disabled' )" target="_blank">
              <i class="fa fa-file-pdf-o"> </i>{{ $t('Generar Presupuesto') }}
            </a> -->
            <a href="#" @click.prevent="tooglePresupuesto()" :class="'buy-link float-right '+ tipo + ( CantidadArticulosMarcados ? '' : ' buy-type-disabled' )">
              {{ $t('Configurar Presupuesto') }}
            </a>
          </td>
          <td colspan="2" class="align-right buy-type">
            <router-link :to="{ name: 'pedido', params: { language: getLocale, tipo: tipo } }" 
            :class="'buy-link '+ tipo + ( CantidadArticulosMarcados ? '' : ' buy-type-disabled' )">{{ $t('Comprar') }}</router-link>
          </td>
          <td></td>
        </tr>
      </tfoot>
    </table>
    <div v-if="showGenerarPresupuesto" class="presupuesto">      
      <div class="row">
        <div class="col-md-4 col-md-offset-1 justify">
          <h4>{{ $t('Configurar Presupuesto') }}</h4>
          <p>{{ $t('Para generar un presupuesto verifique los datos de contacto y si fuera necesario modifiquelos.') }}
          <b>{{ $t('Recuerde que está generando un PRESUPUESTO, no un pedido') }}</b>. {{ $t('Para realizar una pedido pulse en el botón COMPRAR') }}.</p>
        </div>
        <div class="col-md-5 col-md-offset-1 consultas">
          <h5>{{ $t('Datos del pagador') }}</h5>
          <br>
          <div class="input-group">
            <div class="input-group-addon"><span>{{ $t('Organismo') }}</span></div>
            <div class="autocomplete-wrapper">
              <input type="text" id="default" class="form-control"
                v-model="biblioteca.organismo">
            </div> 
          </div>
          <div class="input-group">
            <div class="input-group-addon"><span>NIF</span></div>
            <div class="autocomplete-wrapper">
              <input type="text" id="default" class="form-control"
                v-model="biblioteca.nif">
            </div> 
          </div>
          <div class="form-head fix">
            <div class="input-group">
              <div class="input-group-addon"><span>{{ $t('Dirección') }}</span></div>
              <div class="autocomplete-wrapper">
                <input type="text" id="default" class="form-control"
                  v-model="biblioteca.direccion">
              </div> 
            </div>
            <div class="input-group">
              <div class="input-group-addon"><span>{{ $t('Código postal') }}</span></div>
              <div class="autocomplete-wrapper">
                <input type="text" id="default" class="form-control"
                  v-model="biblioteca.codigo_postal">
              </div> 
            </div>
            <div class="input-group">
              <div class="input-group-addon"><span>{{ $t('Población') }}</span></div>
              <div class="autocomplete-wrapper">
                <input type="text" id="default" class="form-control"
                  v-model="biblioteca.poblacion">
              </div> 
            </div>
          </div>          
          <div class="center mt30 mb40">
            <a href="" @click.prevent="generarPresupuesto()"  :class="'buy-link '+ tipo + ( CantidadArticulosMarcados ? '' : ' buy-type-disabled' )">
              <i class="fa fa-file-pdf-o"> </i>{{ $t('Descargar Presupuesto en PDF') }}
            </a>
            <!-- <a :href=" getApiUrl + '/es/mipresupuesto'" :class="'buy-link '+ tipo + ( CantidadArticulosMarcados ? '' : ' buy-type-disabled' )" target="_blank">
              <i class="fa fa-file-pdf-o"> </i>{{ $t('Descargar Presupuesto en PDF') }}
            </a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Artículo": "Artículo",
    "Nombre": "Nombre",
    "Formato": "Formato",
    "PVP": "PVP",
    "Cantidad": "Cantidad",
    "Importe": "Importe",
    "Comprar": "Comprar",
    "Marcar todos": "Marcar todos",
    "Desmarcar todos": "Desmarcar todos",
    "TOTALES": "TOTALES",
    "Vaciar todas las listas": "Vaciar todas las listas",
    "Artículos marcados": "Artículos marcados",
    "Artículos no marcados": "Artículos no marcados",
    "Generar Presupuesto": "Generar Presupuesto",
    "Configurar Presupuesto": "Configurar Presupuesto",
    "Para generar un presupuesto verifique los datos de contacto y si fuera necesario modifiquelos.": "Para generar un presupuesto verifique los datos de contacto y si fuera necesario modifiquelos.",
    "Recuerde que está generando un PRESUPUESTO, no un pedido": "Recuerde que está generando un PRESUPUESTO, no un pedido",
    "Para realizar una pedido pulse en el botón COMPRAR": "Para realizar una pedido pulse en el botón COMPRAR",
    "Datos del pagador": "Datos del pagador",
    "Organismo": "Organismo",
    "Dirección": "Dirección",
    "Población": "Población",
    "Biblioteca": "Biblioteca",
    "Código postal": "Código postal",
    "Descargar Presupuesto en PDF": "Descargar Presupuesto en PDF"
  },
  "en": {
  },
  "ca": {
    "Artículo": "Article",
    "Nombre": "Nom",
    "Formato": "Format",
    "PVP": "PVP",
    "Cantidad": "Quantitat",
    "Importe": "Import",
    "Comprar": "Comprar",
    "Marcar todos": "Marcar tots",
    "Desmarcar todos": "Desmarcar tots",
    "TOTALES": "TOTALS",
    "Vaciar todas las listas": "Buidar totes les llistes",
    "Artículos marcados": "Articles marcats",
    "Artículos no marcados": "Articles no marcats",
    "Generar Presupuesto": "Generar Pressupost",
    "Configurar Presupuesto": "Configura Pressupost",
    "Para generar un presupuesto verifique los datos de contacto y si fuera necesario modifiquelos.": "Per generar un pressupost verifiqui les dades de contacte i si fos necessari modifiqueu.",
    "Recuerde que está generando un PRESUPUESTO, no un pedido": "Recordeu que està generant un PRESSUPOST, no una comanda",
    "Para realizar una pedido pulse en el botón COMPRAR": "Per realitzar una comanda feu clic al botó COMPRAR",
    "Datos del pagador": "Dades del pagador",
    "Organismo": "Organisme",
    "Dirección": "Direcció",
    "Población": "Població",
    "Biblioteca": "Biblioteca",
    "Código postal": "Codi postal",
    "Descargar Presupuesto en PDF": "Descarregar Pressupost en PDF"
  }
}
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters } from 'vuex';

	export default {
    data: () => {
      return {
        categories: [ 'cine', 'musica', 'infantil', 'libros', 'series', 'documentales', 'juegos' ],
        tipo: 'todo',
        showGenerarPresupuesto: false,
        biblioteca: {}
      }
    },
    created() { },
    mounted(){ 
      this.getPerfil();
    },
    computed: { 
      ...mapGetters(['getMiSeleccion', 'getLocale', 'getApiUrl']),
      MiSeleccion: function(){
        var elements = []; 
        for(var i=0; i<this.categories.length; i++){

          if( this.$store.getters.getMiSeleccion(this.categories[i]) ){
            //console.log(this.$store.getters.getMiSeleccion(this.categories[i]));

            var aux  = this.$store.getters.getMiSeleccion(this.categories[i]);

            for (var j=0; j<aux.length; j++ ){
              elements.splice(0,0, aux[j]);
            }
          }
        }
        return elements;
      },
      ArticulosMarcados: function(){
        if( this.MiSeleccion ){
          return this.MiSeleccion.filter( (item) => item.seleccionado == 1).length;
        }else{ return 0 }
      },
      AllArticulos: function(){
        if( this.MiSeleccion ){
          return this.MiSeleccion.length;
        }else{ return 0 }
      },
      CantidadArticulosMarcados: function(){
        if( this.MiSeleccion ){
          return (this.MiSeleccion.filter( (articulo) => articulo.seleccionado == 1)).reduce(
            (total, articulo) => total + parseInt(articulo.cantidad), 0);
        }else{ return 0 }
      },
      CantidadArticulosNoMarcados: function(){
        if( this.MiSeleccion ){
          return (this.MiSeleccion.filter( (articulo) => articulo.seleccionado == 0)).reduce(
            (total, articulo) => total + parseInt(articulo.cantidad), 0);
        }else{ return 0 }
      },
      ImporteTotalMarcados: function(){
        if( this.MiSeleccion ){
          return (this.MiSeleccion.filter( (articulo) => articulo.seleccionado == 1)).reduce(
            (total, articulo) => total + (articulo.precio * articulo.cantidad), 0).toFixed(2);
        }else{ return 0 }
      },
      ImporteTotalNoMarcados: function(){
        if( this.MiSeleccion ){
          return (this.MiSeleccion.filter( (articulo) => articulo.seleccionado == 0)).reduce(
            (total, articulo) => total + (articulo.precio * articulo.cantidad), 0).toFixed(2);
        }else{ return 0 }
      },
      MiSeleccionLength: function(){
        if( this.MiSeleccion ){
          return this.MiSeleccion.length;
        }else{ return 0 }
      },
     },
    methods:{
      checkAll(){
        for(var i=0; i<this.categories.length; i++){
          if( !(Object.keys(this.$store.getters.getMiSeleccion(this.categories[i])).length === 0) && !(this.$store.getters.getMiSeleccion(this.categories[i]).constructor === Object) ){
            this.$store.dispatch('checkAllArticulosTipo', { tipo: this.categories[i] } ); 
          }
        }
      },
      uncheckAll(){
        for(var i=0; i<this.categories.length; i++){
          if( !(Object.keys(this.$store.getters.getMiSeleccion(this.categories[i])).length === 0) && !(this.$store.getters.getMiSeleccion(this.categories[i]).constructor === Object) ){
            this.$store.dispatch('uncheckAllArticulosTipo', { tipo: this.categories[i] } );
          }
        }
        
      },
      deleteAll(){
        if( confirm('¿Estás seguro de borrar todos los artículos?') ){
          for(var i=0; i<this.categories.length; i++){
            if( !(Object.keys(this.$store.getters.getMiSeleccion(this.categories[i])).length === 0) && !(this.$store.getters.getMiSeleccion(this.categories[i]).constructor === Object) ){
              this.$store.dispatch('deleteAllArticulosTipo', { tipo: this.categories[i] } );
            }
          }
        }
      },
      tooglePresupuesto(){
        this.showGenerarPresupuesto = !this.showGenerarPresupuesto;
      },
      getPerfil(){
        axios.get(this.getApiUrl + this.getLocale + '/miperfil?ref=miseleccion')
        .then( (respuesta) =>{   
            this.biblioteca = respuesta.data.data;
            this.biblioteca['organismo'] = '';
            this.biblioteca['nif'] = '';
          })  
          .catch( (error) =>{ 
            this.error_message = error.response.data.status + ' ' + error.response.data.msg;
            this.error = true;     
          }) 
      },
      generarPresupuesto(){
        let dataToSend = this.biblioteca;

        delete dataToSend.id;     delete dataToSend.CODICLI;  delete dataToSend.provincia;  
        delete dataToSend.email;  delete dataToSend.telefono;

        window.open(this.getApiUrl + this.getLocale + '/mipresupuesto?' + jQuery.param(this.biblioteca) );
        //console.log(this.getApiUrl + this.getLocale + '/mipresupuesto?' + this.getApiUrl + this.getLocale + '/mipresupuesto?' + jQuery.param(this.biblioteca) );
      },
    },
    watch:{}
  }
</script>
